
















































































































































































































































































































































































































































































































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import MyForm from "@/mixins/form";
import _ from "lodash";
import moment from "moment";

import EquipMaster from "./equipment_master.vue";
import EquipSwitch from "./equipment_switch.vue";

@Component({
  components: {
    EquipMaster,
    EquipSwitch
  }
})
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  loading = false;

  interfaceType: string[] = ["ModBus", "RS485"];

  stadiumName = "";

  ailocalversion = "";

  mainEquipmentCount = 0;

  switchEquipmentCount = 0;

  subEquipmentCount = 0;

  oldSwitchEquipments: any = [];

  mainEquipOptions: any[] = [
    {
      id: "1",
      name: "AI主机"
    },
    {
      id: "2",
      name: "人脸识别"
    },
    {
      id: "3",
      name: "二维码识别"
    },
    {
      id: "4",
      name: "UPS断电保护"
    },
    {
      id: "5",
      name: "摄像头"
    },
    {
      id: "7",
      name: "售卖柜"
    }
  ];

  commonEquipArr: any[] = [
    {
      id: "1",
      name: "门禁"
    },
    {
      id: "6",
      name: "行为识别"
    },
    {
      id: "7",
      name: "应急门"
    },
    {
      id: "8",
      name: "门禁灯"
    },
    {
      id: "9",
      name: "门禁开闭监视器"
    },
    {
      id: "10",
      name: "门禁警报器"
    },
    {
      id: "11",
      name: "智慧路灯"
    },
    {
      id: "12",
      name: "猫路由器"
    },
    {
      id: "13",
      name: "开门提示音"
    },
    {
      id: "14",
      name: "智能柜锁"
    },
    {
      id: "15",
      name: "配电箱锁"
    },
    {
      id: "16",
      name: "报警灯"
    },
    {
      id: "17",
      name: "智能柜锁监视器"
    },
    {
      id: "18",
      name: "配电箱锁监视器"
    }
  ];

  equipArr: any[] = [
    {
      id: "3",
      name: "照明灯"
    },
    {
      id: "4",
      name: "广告灯"
    },
    {
      id: "2",
      name: "场地灯"
    },
    {
      id: "5",
      name: "升降机"
    },
    {
      id: "19",
      name: "直播杆"
    }
  ];

  renderReportTime(time: string) {
    if (time == "0001-01-01T00:00:00Z") {
      return "";
    }

    return time;
  }

  async loadData1() {
    this.spinLoading = true;
    this.loading = true;
    const val = Number(this.stadiumId);
    // this.stadiumId = this.stadiumId

    let mainEquipment: any[] = [];
    // 主设备
    const res = await this.$store.dispatch("stadium/getStadiumMainEquipments", {
      stadium_id: this.stadiumId
    });

    if (res && res.Data && res.Data.length > 0) {
      // 有配置过主设备
      for (const obj of res.Data) {
        // obj.status = 1;
        let control_rule1 = [];
        if (obj.control_rule === "{}") {
          control_rule1 = [];
        } else {
          const control_rule2 = JSON.parse(obj.control_rule);
          if (obj.type === 6 || obj.type === 8) {
            control_rule1 = control_rule2;
          } else {
            // 重构成{key：'', value: ''}结构
            for (const key in control_rule2) {
              if (_.has(control_rule2, key)) {
                control_rule1.push({
                  key,
                  value: control_rule2[key]
                });
              }
            }
          }
        }
        obj.control_rule = control_rule1;
      }
      mainEquipment = res.Data;
      this.mainEquipmentCount = res.Data.length;
    } else {
      // 没有配置过主设备
      mainEquipment = [
        {
          id: null,
          name: "AI主机",
          code: "",
          control_rule: [],
          status: 1,
          type: 1,
          stadium_id: this.stadiumId,
          permission: 0
        },
        {
          id: null,
          name: "人脸识别",
          code: "face01",
          control_rule: [
            { key: "ip", value: "192.168.1.11" },
            { key: "port", value: "8000" },
            { key: "login", value: "admin" },
            { key: "password", value: "" },
            { key: "userMax", value: "5000" }
          ],
          status: 1,
          type: 2,
          stadium_id: this.stadiumId,
          permission: 0
        },
        {
          id: null,
          name: "二维码识别",
          code: "qrcode",
          control_rule: [{ key: "com", value: "/dev/ttyS0" }, { key: "baud", value: "9600" }],
          status: 1,
          type: 3,
          stadium_id: this.stadiumId,
          permission: 0
        },
        {
          id: null,
          name: "UPS断电保护",
          code: "ups01",
          control_rule: [{ key: "com", value: "/dev/ttyS4" }, { key: "baud", value: "2400" }],
          status: 1,
          type: 4,
          stadium_id: this.stadiumId,
          permission: 0
        },
        {
          id: null,
          name: "摄像头",
          code: "",
          control_rule: [
            { key: "brand", value: "海康威视" }
            // { key: 'model', value: '' },
            // { key: 'serialnumber', value: '' },
            // { key: 'ip', value: '' },
            // { key: 'network', value: '' },
          ],
          status: 1,
          type: 5,
          stadium_id: this.stadiumId,
          permission: 0
        },
        {
          id: null,
          name: "售卖柜",
          code: "",
          control_rule: [
            { key: "com", value: "" },
            { key: "baud", value: "" },
            { key: "start", value: "1" },
            { key: "end", value: "14" }
          ],
          status: 1,
          type: 7,
          stadium_id: this.stadiumId,
          permission: 0
        }
      ];

      this.mainEquipmentCount = mainEquipment.length;
    }

    // 集结器
    const res1 = await this.$store.dispatch("stadium/getStadiumSwitchEquipments", {
      stadium_id: val
    });
    // console.log(res1);
    let switchEquipment: any = [];

    if (res1 && res1.Data && res1.Data.length > 0) {
      for (const obj of res1.Data) {
        // obj.status = 1;
        let control_rule1 = [];
        if (obj.control_rule === "{}") {
          control_rule1 = [];
        } else {
          const control_rule2 = JSON.parse(obj.control_rule);
          // 重构成{key：'', value: ''}结构
          for (const key in control_rule2) {
            if (_.has(control_rule2, key)) {
              control_rule1.push({
                key,
                value: control_rule2[key]
              });
            }
          }
        }
        obj.control_rule = control_rule1;
      }
      switchEquipment = res1.Data;
      this.switchEquipmentCount = res1.Data.length;
    } else {
      switchEquipment = [
        {
          id: 0,
          type: 0,
          index: 0,
          status: 1,
          name: "集结器1",
          description: "switch01",
          code: "",
          stadium_id: this.stadiumId,
          control_rule: [
            { key: "ip", value: "192.168.0.13" },
            { key: "port", value: "50000" },
            { key: "login", value: "" },
            { key: "password", value: "" },
            { key: "rs485_port", value: "50002" }
          ]
        }
      ];
      this.switchEquipmentCount = switchEquipment.length;
    }

    // 场地
    const res3 = await this.$store.dispatch("stadium/getStadiumGrounds", {
      stadium_id: val
    });
    // console.log(res3);
    const grounds: any = {};
    // 公共子设备
    grounds["itm0" as string] = {
      id: 0,
      name: "公共设备",
      equipment: []
    };

    // 场地对应设备
    for (const itm of res3.Data) {
      // console.log(itm);
      grounds[`itm${itm.id}`] = {
        id: itm.id,
        name: itm.name,
        equipment: []
      };
    }

    // 二级设备
    const res2 = await this.$store.dispatch("stadium/getStadiumSubEquipments", {
      stadium_id: val
    });
    // 二级设备数据
    // console.log(res2.Data);
    console.log(grounds);
    const tarr1: { [t: string]: any } = {};
    for (const sub of res2.Data) {
      const obj = grounds[`itm${sub.equipment_sub.ground_id}`];

      let obj1name = "";
      if (String(sub.equipment_sub.ground_id) === "0") {
        // 公共设备
        const obj1 = _.find(
          this.commonEquipArr,
          (o: any) => Number(o.id) === Number(sub.equipment_sub.type)
        );
        obj1name = sub.equipment_sub.name || (obj1 && obj1.name);
      } else {
        // 场地设备
        const obj1 = _.find(
          this.equipArr,
          (o: any) => Number(o.id) === Number(sub.equipment_sub.type)
        );
        obj1name = sub.equipment_sub.name || (obj1 && obj1.name);
      }

      if (obj) {
        obj.equipment.push({
          id: sub.equipment_sub.id,
          status: sub.equipment_sub.status,
          description: sub.equipment_sub.description,
          note: sub.equipment_sub.note,
          permission: sub.equipment_sub.permission,
          report_time: sub.equipment_sub.report_time,
          name: obj1name,
          // id: sub.equipment_sub.id,
          switch_id: parseInt(sub.equipment_sub.switch_id, 10),
          switch_port_type: parseInt(sub.switch_port_binds[0].switch_port_type, 10),
          switch_port_code: sub.switch_port_binds[0].switch_port_code,
          type: parseInt(sub.equipment_sub.type, 10)
        });
      } else {
        console.log(obj);
        console.log(`itm${sub.equipment_sub.ground_id}`);
      }
    }

    // 升降机
    for (const master of mainEquipment) {
      if (parseInt(master.type, 10) === 6) {
        // console.log(master);
        const obj = grounds[`itm${master.stadium_ground_id}`];
        // console.log(master.control_rule);
        master.control_rule.id = master.id;
        master.control_rule.type = 5;
        // console.log(master.control_rule);
        master.control_rule.name = master.name || "升降机";
        master.control_rule.note = master.description;
        master.control_rule.status = master.status;
        master.control_rule.permission = master.permission;
        master.control_rule.report_time = master.report_time;
        if (obj) {
          obj.equipment.push(master.control_rule);
        }
      }
    }

    // 直播杆
    for (const master of mainEquipment) {
      if (parseInt(master.type, 10) === 8) {
        // console.log(master);
        const obj = grounds[`itm${master.stadium_ground_id}`];
        // console.log(master.control_rule);
        master.control_rule.id = master.id;
        master.control_rule.type = 19;
        // console.log(master.control_rule);
        master.control_rule.name = master.name || "直播杆";
        master.control_rule.note = master.description;
        master.control_rule.status = master.status;
        master.control_rule.permission = master.permission;
        master.control_rule.report_time = master.report_time;
        if (obj) {
          obj.equipment.push(master.control_rule);
        }
      }
    }

    this.oldSwitchEquipments = _.cloneDeep(switchEquipment);
    // console.log(grounds)
    // console.log(mainEquipment);
    this.formData = {
      mainEquipment,
      switchEquipment,
      grounds
    };

    this.loading = false;
    this.spinLoading = false;
  }

  async mounted() {
    const res = await this.$store.dispatch("stadium/getStadium",{
      stadium_id:this.stadiumId,
    });
    if(res.Code==200 && res.Data && res.Data.stadium_info){
      this.stadiumName=res.Data.stadium_info.name
    }
    this.loadData1();
  }

  addMainItem() {
    this.formData.mainEquipment.push({
      id: null,
      name: "设备",
      code: "",
      control_rule: [],
      status: 1,
      type: 0,
      stadium_id: this.stadiumId,
      permission: 0
    });
  }

  removeMainItem(index: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要移除吗？",
      onOk: () => {
        this.formData.mainEquipment.splice(index, 1);
      }
    });
  }

  addSwitchItem() {
    const idx = this.formData.switchEquipment.length + 1;

    this.formData.switchEquipment.push({
      id: null,
      type: 0,
      index: idx,
      status: 1,
      name: `集结器${idx}`,
      code: "",
      stadium_id: this.stadiumId,
      control_rule: [
        { key: "ip", value: "192.168.0.13" },
        { key: "port", value: "50000" },
        { key: "login", value: "" },
        { key: "password", value: "" },
        { key: "rs485_port", value: "50002" }
      ]
    });
    // 直接产生一条集线器记录
    // 然后刷新formData.switchEquipment的记录
  }

  removeSwitchItem(index: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要移除吗？",
      onOk: () => {
        this.formData.switchEquipment[index].status = 0;
      }
    });

    // 删除
  }

  // 添加规则配置项
  addControlRule(equip: string, index: number) {
    if (equip === "main") {
      this.formData.mainEquipment[index].control_rule.push({
        key: "",
        value: ""
      });
    } else {
      this.formData.switchEquipment[index].control_rule.push({
        key: "",
        value: ""
      });
    }
  }

  // 移除规则配置项
  removeControlRule(equip: string, index: number, key: number) {
    this.$confirm({
      title: "确认信息",
      content: "确定要移除吗？",
      onOk: () => {
        if (equip === "main") {
          this.formData.mainEquipment[index].control_rule.splice(key, 1);
        } else {
          this.formData.switchEquipment[index].control_rule.splice(key, 1);
        }
      }
    });
  }

  // 添加二级设备的数量
  addSubItem(ground_id: number) {
    this.formData.grounds[`itm${ground_id}`].equipment.push({
      switch_id: 0,
      switch_port_type: 0,
      switch_port_code: "0",
      type: 0
    });
  }

  removeSubItem(ground_id: number, idx: number) {
    this.$confirm({
      title: "确认信息",
      content: "确认要移除吗？",
      onOk: () => {
        this._removeSubItem(ground_id, idx);
      }
    });
  }

  _removeSubItem(ground_id: number, idx: number) {
    const grounds = _.cloneDeep(this.formData.grounds);
    // console.log(idx)
    // console.log(grounds)
    // _.unset(grounds, [`itm${ground_id}`, 'equipment', `${idx}`])
    grounds[`itm${ground_id}`].equipment.splice(idx, 1);
    // console.log(grounds)
    this.formData.grounds = grounds;
  }

  // 更新switchEquipment
  changeSwitchEquipment(equips: any[]) {
    this.oldSwitchEquipments = _.cloneDeep(equips);
    this.formData.switchEquipment = equips;
  }

  async handleSubmit(name: string) {
    if (name === "saveEquipment") {
      this.showTsConfirm({
        title: "确认信息",
        content: "你确定要提交吗？",
        onOk: async () => {
          const mainEquipment1: any[] = JSON.parse(JSON.stringify(this.formData.mainEquipment));

          // console.log(mainEquipment1);
          _.remove(mainEquipment1, (n: any) => parseInt(n.type, 10) === 6 || parseInt(n.type, 10) === 8);
          // console.log(mainEquipment1);
          // return
          let switchEquipment1: any[] = JSON.parse(JSON.stringify(this.formData.switchEquipment));
          const subEquipment: any[] = JSON.parse(JSON.stringify(this.formData.grounds));
          const newSubEquipment: any[] = [];

          for (const key in subEquipment) {
            if (subEquipment[key]) {
              const obj = subEquipment[key];
              // console.log(obj);
              for (const key1 in obj.equipment) {
                if (obj.equipment[key1]) {
                  const obj1 = obj.equipment[key1];
                  const eqType=parseInt(obj1.type, 10);
                  if (eqType === 5 || eqType === 19) {
                    // 升降机， 不加入二级设备，加入到主设备中去，二级设备type是5，主设备type是6
                    // console.log(obj1)
                    // console.log(!obj1.id)
                    // if (!obj1.id) {
                    mainEquipment1.push({
                      CreatedTime: moment().format("YYYY-MM-DDThh:mm:ssZ"),
                      UpdatedTime: moment().format("YYYY-MM-DDThh:mm:ssZ"),
                      id: obj1.id,
                      name: obj1.name || (eqType === 5?"升降":"直播杆"),
                      code: eqType === 5?"up_down":"video_lifter",
                      control_rule: {
                        com: obj1.com,
                        baud: obj1.baud,
                        rs485_id: obj1.rs485_id,
                        rs485_chan: obj1.rs485_chan
                      },
                      description: obj1.note || (eqType === 5?"升降":"直播杆"),
                      stadium_ground_id: obj.id,
                      stadium_id: this.stadiumId,
                      type: eqType==5?6:8,
                      permission: obj1.permission
                    });
                    // }
                  } else {
                    // 二级设备保存
                    newSubEquipment.push({
                      equipment_sub: {
                        id: obj1.id,
                        // control_rule: "{}",
                        description: obj1.description,
                        note: obj1.note,
                        permission: obj1.permission,
                        name: obj1.name,
                        // equipment_status: 1,
                        // equipment_sub_code: "",
                        equipment_sub_id: obj1.id,
                        ground_id: obj.id,
                        stadium_id: this.stadiumId,
                        // status: 1,
                        // status_desc: "",
                        // status_keep: 1,
                        // switch_code: "",
                        switch_id: obj1.switch_id,
                        switch_port_code: `${obj1.switch_port_code}`,
                        // switch_port_id: 0,
                        switch_port_type: obj1.switch_port_type,
                        type: parseInt(obj1.type, 10)
                      },
                      stadium_id: this.stadiumId,
                      switch_port_binds: [
                        {
                          id: obj1.id,
                          equipment_sub_id: obj1.id,
                          // control_rule: "{}",
                          description: obj1.description,
                          name: obj1.name,
                          ground_id: obj.id,
                          stadium_id: this.stadiumId,
                          switch_id: obj1.switch_id,
                          switch_port_code: `${obj1.switch_port_code}`,
                          // switch_port_id: 0,
                          switch_port_type: obj1.switch_port_type,
                          type: parseInt(obj1.type, 10)
                        }
                      ]
                    });
                  }
                }
              }
            }
          }

          mainEquipment1.map((itm1: any) => {
            itm1.type = Number(itm1.type);
            itm1.permission = Number(itm1.permission);
            if (itm1.control_rule) {
              if (_.isArray(itm1.control_rule)) {
                // 处理回object
                const control_rule = {};
                for (const itm of itm1.control_rule) {
                  _.set(control_rule, itm.key, itm.value);
                }
                // console.log(control_rule);
                itm1.control_rule = JSON.stringify(control_rule);
              } else {
                itm1.control_rule = JSON.stringify(itm1.control_rule);
              }
            } else {
              itm1.control_rule = JSON.stringify({});
            }

            return itm1;
          });
          switchEquipment1.map((itm1: any) => {
            itm1.permission = Number(itm1.permission);
            if (itm1.control_rule) {
              if (_.isArray(itm1.control_rule)) {
                const control_rule = {};
                for (const itm of itm1.control_rule) {
                  _.set(control_rule, itm.key, itm.value);
                }
                // console.log(control_rule);
                itm1.control_rule = JSON.stringify(control_rule);
              } else {
                itm1.control_rule = JSON.stringify(itm1.control_rule);
              }
            } else {
              itm1.control_rule = JSON.stringify({});
            }

            return itm1;
          });
          switchEquipment1 = _.filter(switchEquipment1, (o: any) => o.status);
          // console.log(mainEquipment1);
          // return
          // console.log(switchEquipment1);
          this.confirmLoading = true;
          // 保存主设备配置
          const res=await this.$store.dispatch(
            "stadium/saveStadiumMainEquipment",
            JSON.stringify({
              stadium_id: Number(this.stadiumId),
              e_mains: mainEquipment1,
              e_switchs: switchEquipment1
            })
          );
          if (res && res.Message && res.Message !== "success") {
            this.$message.error(res.Message);
            return
          }
          // // 保存二级设备配置
          await this.$store.dispatch(
            "stadium/saveStadiumSubEquipment",
            JSON.stringify(newSubEquipment)
          );

          // 更新
          this.$store
            .dispatch("stadium/getStadiumSwitchEquipments", {
              stadium_id: this.stadiumId
            })
            .then((res1: any) => {
              // console.log(res1);
              // let switchEquipment: any = [];

              if (res1 && res1.data && res1.data.length > 0) {
                for (const obj of res1.data) {
                  obj.status = 1;
                  let control_rule1 = [];
                  if (obj.control_rule === "{}") {
                    control_rule1 = [];
                  } else {
                    const control_rule2 = JSON.parse(obj.control_rule);
                    // 重构成{key：'', value: ''}结构
                    for (const key in control_rule2) {
                      if (_.has(control_rule2, key)) {
                        control_rule1.push({
                          key,
                          value: control_rule2[key]
                        });
                      }
                    }
                  }
                  obj.control_rule = control_rule1;
                }
                // switchEquipment = res1.data;
                this.changeSwitchEquipment(res1.data);
              }
            });

          this.confirmLoading = false;
          // 刷新一下数据
          this.loadData1();
          this.$message.success("保存成功");
        }
      });
    } else if (name === "deliverEquipSetting") {
      this.showTsConfirm({
        title: "确认信息",
        content: "确认要下发配置吗？",
        onOk: () => {
          this.deliverSetting();
        }
      });
    } else if (name === "updateAiLocal") {
      const h = this.$createElement;
      this.$confirm({
        content: h("a-input", {
          props: {
            value: this.ailocalversion,
            autofocus: true,
            placeholder: "输入版本号"
          },
          on: {
            input: (e: any) => {
              // console.log(e.target.value)
              this.ailocalversion = e.target.value;
            }
          }
        }),
        onOk: async () => {
          if (this.ailocalversion) {
            this.showTsConfirm({
              title: "确认信息",
              content: "你确定要提交吗？",
              onOk: async () => {
                const res = await this.$store.dispatch("stadium/sendCommand", {
                  command: JSON.stringify({
                    Uid: 0,
                    Code: "execute",
                    Target: "system",
                    Data: JSON.stringify({
                      file_name: "update.sh",
                      file_type: 1,
                      args: [this.ailocalversion]
                    })
                  }),
                  uc: this.formData.mainEquipment[0].code
                });
                // console.log(res)
                if (res && res.Message && res.Message === "success") {
                  this.$message.success("命令发送成功");
                } else {
                  this.$message.error(res.Message);
                }
              }
            });
          } else {
            this.$message.error("请输入版本号");
          }
        }
      });
    } else if (name === "refreshEquipStatus") {
      this.$confirm({
        title: "确认信息",
        content: "确认要下发刷新设备状态指令吗？",
        onOk: async () => {
          const res = await this.$store.dispatch("stadium/refreshEquipStatus", {
            stadium_id: this.stadiumId
          });
          this.$message.success("操作成功");
        }
      });
    } else if (name==="initEquipment"){
      this.showTsConfirm({
          title: "确认信息",
          content: `初始化时原先的配置将被清除，您确定要重新初始化配置吗？`,
          onOk: async () => {
            // 需要判断权限
            if (!this.checkPermission("admin-stadiums-edit")) {
              this.$message.warning("没有权限");
              return;
            }
            const res = await this.$store.dispatch("stadium/initStadiumEquipment", {
              stadium_id: this.stadiumId
            });
            if (res && res.Message && res.Message === "success") {
              this.$message.success("操作成功");
            } else {
              this.$message.error(res.Message);
            }
          },
          onCancel: () => {
          }
      });
    }
  }

  async deliverSetting() {
    const res = await this.$store.dispatch("stadium/deliverStadiumEquip", {
      id: this.stadiumId
    });
    this.$message.success("下发成功");
  }

  restartSubEquip(subid: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: "确定要重启该设备吗？",
      onOk: async () => {
        const res = await this.$store.dispatch("stadium/restartSubEquip", {
          sub_id: subid
        });
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }

  toggleSubEquip(etype: number, subid: number, ctrl_type: number, groundId?: number) {
    this.showTsConfirm({
      title: "确认信息",
      content: `确定要${ctrl_type ? "打开" : "关闭"}该设备吗？`,
      onOk: async () => {
        let action = "stadium/toggleSubEquip";
        const params: any = {
          stadium_id: this.stadiumId,
          sub_id: subid,
          ctrl_type
        };

        if (etype === 5) {
          action = "stadium/toggleMainEquip";
          params.ground_id = groundId;
        }
        if (etype === 19) {
          action = "stadium/toggleVideoEquip";
          params.ground_id = groundId;
        }

        const res = await this.$store.dispatch(action, params);
        if (res && res.Message && res.Message === "success") {
          this.$message.success("操作成功");
          this.loadData1();
        } else {
          this.$message.error(res.Message);
        }
      }
    });
  }
}
